export const responseBigQueryValidationEncryption = {
  data: {
    attributes: {
      serviceAccount: 'big-query-validation-encryption-response'
    }
  }
};